import { render } from "./ButtonDelete.vue?vue&type=template&id=fa28d6b4"
import script from "./ButtonDelete.vue?vue&type=script&lang=js"
export * from "./ButtonDelete.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__